import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import t from "@/lang/lang";

export function ManageBuildingLoadingAndError({
  isLoading,
  processError,
  addressError,
  buildingError,
  hasProcess,
  hasAddressList,
}: {
  isLoading: boolean;
  processError: unknown;
  addressError: unknown;
  buildingError: unknown;
  hasProcess: boolean;
  hasAddressList: boolean;
}) {
  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (processError) {
    return <RTKQueryErrorAlert error={processError} />;
  }

  if (addressError) {
    return <RTKQueryErrorAlert error={addressError} />;
  }

  if (buildingError) {
    return <RTKQueryErrorAlert error={buildingError} />;
  }

  if (!hasProcess) {
    return <div>{t("Fehler beim Laden der Vorgangsdaten!")}</div>;
  }

  if (!hasAddressList) {
    return <div>{t("Fehler beim laden der Addressdaten")}</div>;
  }

  return null;
}
